import script from './component-lib.esm2.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', _vm._g(_vm._b({
    ref: "root",
    staticClass: "v-img-wh",
    class: _vm.classes,
    on: {
      "click": _vm.handleClick
    }
  }, 'div', _vm.$attrs, false), _vm.$listeners), [_vm.ratio ? _c('RatioBox', {
    staticClass: "v-img-wh__ratio",
    attrs: {
      "ratio": _vm.ratio
    }
  }, [_c('img', _vm._b({
    on: {
      "load": _vm.handleImgLoad
    }
  }, 'img', _vm.imgAttrs, false))]) : _c('img', _vm._b({
    on: {
      "load": _vm.handleImgLoad
    }
  }, 'img', _vm.imgAttrs, false)), _vm._v(" "), (_vm.showHighlights || _vm.isEditing) && _vm.imgHasLoaded ? [_vm._l(_vm.highlights, function (h, i) {
    return [_vm.isEditing && i === _vm.editHighlight || !_vm.isEditing ? _c('ImageHighlight', {
      key: i,
      attrs: {
        "position": h
      }
    }, [_vm._v(_vm._s(i + 1))]) : _vm._e()];
  })] : _vm._e()], 2);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-530b1330_0", {
    source: ".v-img-wh[data-v-530b1330]{display:inline-flex;position:relative;overflow:hidden}.v-img-wh--editing[data-v-530b1330]{cursor:pointer}.v-img-wh__ratio[data-v-530b1330]{width:100%}.v-img-wh img[data-v-530b1330]{max-width:unset;width:100%;height:auto}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = "data-v-530b1330";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var ImageWithHighlights = __vue_component__;
export { ImageWithHighlights as default };